import React, { useState, useRef } from 'react'
import { Col, Row, message, ConfigProvider, Pagination} from 'antd'
import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { BACKEND_API_URL } from '../../../constants/constants';
import { sendHttpPostRequest } from '../../../api/http-request'
import zhCN from 'antd/lib/locale/zh_CN'
import teacherStudentStyles from '../student-list/course-main-teacher-student.module.less'
import shiyanEmpty from '../../../static/image/empty/queshengye-shiyan.png'

import Icon from '@ant-design/icons'

import { ReactComponent as manSvg }   from '../../../static/image/course/man.svg'
import { ReactComponent as womanSvg }   from '../../../static/image/course/woman.svg'
import { ReactComponent as genderUnknownSvg }   from '../../../static/image/course/unknown.svg'

const manIcon = (props:any) => (<Icon component={manSvg} {...props} />)
const womanIcon = (props:any) => (<Icon component={womanSvg} {...props} />)
const genderUnknownIcon = (props:any) => (<Icon component={genderUnknownSvg} {...props} />)





export interface memberProps {
  course_id: any
}

export const CourseMainMemberList: React.FC<memberProps> = (props) => {
  const { course_id,} = props
  const [totalSum, setTotalSum] = useState(0)

  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(12) // 记录当前每页展示数量
  const [memberList, setMemberList] = useState ([] as any)

  useEffect(() => {
    queryCourseMember()
  }, [])


  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryCourseMember()
  }


  const queryCourseMemberCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      setMemberList(response.query_list)
      setTotalSum(response.total_sum)
    } else {
      message.error(response.message)
    }
  }

  const queryCourseMember = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        //college_id: getCollegeId(),
        course_id: course_id,
        type: 0,
        //query:'',
        page: page.current,
        pagesize: pageSize.current,
        //order: order.current,
        //order_by: order_by.current,
        //role: JSON.stringify(roleFilters.current),

      },
      queryCourseMemberCallback
    )
  }


  return (
    <div >

          <Row gutter={[24, 24]} justify="start"  align="middle" wrap={true}>
            {memberList?.map((sudent:any, studentIndex) => {
              return (
                <Col span={8} key={sudent?.user_id}>
                  <div 
                    className={teacherStudentStyles.userCard} style={{height:'100%', width:'100%',border:'1px solid #e5e7eb'}}
                  >

                    <Row wrap={false} align={"top"} >
                      <Col flex={"64px"} style={{marginRight:16}}>
                        <div>
                            <img
                              src={BACKEND_API_URL + sudent?.avatar}
                              style={{height:'64px', width:'64px', borderRadius:8}}
                            />
                        </div>
                      </Col>

                      <Col flex={"auto"} style={{textAlign:'left'}}>
                        <div>
                          <div className={teacherStudentStyles.userCardName}>{sudent?.real_name !== ''? sudent.real_name : sudent?.name}</div>
                          <div>
                            <span className={teacherStudentStyles.userCardRoleLabel} style={{color:sudent?.role == '教师'? "#07c160": sudent?.role == '助教'? "#2563EB":'#4b5563' , background:sudent?.role == '教师'? "#E6F7EF":sudent?.role == '助教'?'#DBEAFE':'#f3f4f6'}}>{sudent?.role}</span>

                            <span style={{marginLeft:8}}><Icon  component={sudent?.sex==2? manIcon:sudent?.sex==3?womanIcon:genderUnknownIcon}/></span>
                            <span style={{color:"#6b7280", fontSize:14,marginLeft:3}}>{sudent?.sex==2?"男":sudent?.sex==3?"女":'未知' }</span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className={teacherStudentStyles.userCardContentDiv}>
                      <Row wrap={false} align={"middle"}>
                        <Col flex={"100px"}>
                          <div className={teacherStudentStyles.userCardContentItem}>
                              账号
                          </div>
                        </Col>
                        <Col flex={"auto"}>
                          <div className={teacherStudentStyles.userCardContentValue}>
                            {sudent?.register_type == 1 ?  sudent?.phone : sudent?.email}
                          </div>
                        </Col>
                      </Row>

                      <Row wrap={false} align={"middle"} style={{margin:'8px 0 0'}}>
                        <Col flex={"100px"}>
                          <div className={teacherStudentStyles.userCardContentItem}>
                              学号/工号
                          </div>
                        </Col>
                        <Col flex={"auto"}>
                          <div className={teacherStudentStyles.userCardContentValue}>
                             {sudent?.number}
                          </div>
                        </Col>
                      </Row>

                      <Row wrap={false} align={"middle"} style={{margin:'8px 0 0'}}>
                        <Col flex={"100px"}>
                          <div className={teacherStudentStyles.userCardContentItem}>
                              加入时间
                          </div>
                        </Col>
                        <Col flex={"auto"}>
                          <div className={teacherStudentStyles.userCardContentValue}>
                            {sudent?.join_time}
                          </div>
                        </Col>
                      </Row>
                    </div>


                </div>
                </Col>
              )
            })}
          </Row>

          {memberList.length == 0 && (
            <div style={{ textAlign: 'center', paddingTop: 20 }}>
              <img src={shiyanEmpty} width={120} height={120} />
              <div style={{ color: '#999', marginTop: 10 }}>
                没有找到或没有成员~
              </div>
            </div>
          )}


            <ConfigProvider locale={zhCN}>
              <Pagination
                //className={teacherStudentStyles.pagination}
                style={{ marginTop: 20 }}
                size={'default'}
                defaultCurrent={1}
                total={totalSum}
                hideOnSinglePage={true}
                current={page.current}
                onChange={onPageChange}
                //onChange={}
                defaultPageSize={pageSize.current}
              />
            </ConfigProvider>
        
    </div>
  )
}

export default CourseMainMemberList
